import { SVGProps } from 'react'

const LineQrType = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={24}
		height={24}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<g clipPath="url(#clip0_293_81)">
			<path
				d="M7.55424 5.34717H5.29297V7.60703H7.55424V5.34717Z"
				fill="currentColor"
			/>
			<path
				d="M14.9708 17.1761H12.7109V19.4374H14.9708V17.1761Z"
				fill="currentColor"
			/>
			<path
				d="M21.7501 14.916H19.4902V17.1758H21.7501V14.916Z"
				fill="currentColor"
			/>
			<path
				d="M17.2293 14.916H14.9708V12.6572H12.7109V14.917H14.9708V17.1758H17.2307V14.917H19.4898V12.6572H17.2293V14.916Z"
				fill="currentColor"
			/>
			<path
				d="M19.4891 19.4357H17.2285V21.6962H19.4891V19.4357Z"
				fill="currentColor"
			/>
			<path
				d="M2.90274 10.6512H9.94433C10.3047 10.6512 10.5967 10.3591 10.5971 9.99876V2.95645C10.5971 2.59579 10.305 2.30371 9.94433 2.30371H2.90274C2.54208 2.30371 2.25 2.59579 2.25 2.95645V9.99876C2.25 10.3591 2.54208 10.6512 2.90274 10.6512ZM3.55514 3.60886H9.29159V9.34602H3.55514V3.60886Z"
				fill="currentColor"
			/>
			<path
				d="M17.9259 5.34717H15.666V7.60703H17.9259V5.34717Z"
				fill="currentColor"
			/>
			<path
				d="M13.2738 10.6512H20.3169C20.6772 10.6512 20.9693 10.3591 20.9696 9.99876V2.95645C20.9696 2.59579 20.6775 2.30371 20.3169 2.30371H13.2738C12.9132 2.30371 12.6211 2.59579 12.6211 2.95645V9.99842C12.6211 10.3591 12.9132 10.6512 13.2738 10.6512ZM13.9262 3.60886H19.6641V9.34602H13.9262V3.60886Z"
				fill="currentColor"
			/>
			<path
				d="M7.56846 15.7038H5.30859V17.9637H7.56846V15.7038Z"
				fill="currentColor"
			/>
			<path
				d="M9.95945 12.6596H2.91642C2.55575 12.6596 2.26367 12.9517 2.26367 13.3123V20.3547C2.26367 20.7153 2.55575 21.0074 2.91642 21.0074H9.95945C10.3198 21.0074 10.6118 20.715 10.6122 20.3547V13.3123C10.6122 12.9517 10.3201 12.6596 9.95945 12.6596ZM9.3067 19.7019H3.56882V13.9651H9.3067V19.7019Z"
				fill="currentColor"
			/>
		</g>
		<defs>
			<clipPath id="clip0_293_81">
				<rect
					width={19.5}
					height={19.5}
					fill="white"
					transform="translate(2.25 2.25)"
				/>
			</clipPath>
		</defs>
	</svg>
)
export { LineQrType }
